import * as React from 'react';
import styled from 'styled-components';
import { CircularProgress } from './CircularProgress';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(50vh);
  text-align: center;
`;

export class LoadingScreen extends React.PureComponent<{}, {}> {
  public render() {
    return (
      <Wrapper>
        <CircularProgress size={52} />
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/LoadingScreen.tsx